import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const CaretRightIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-r-caret-icon': true,
      [className]: className,
    })}
    name={IconNames.CARET_RIGHT}
    size={size}
    {...rest}
  />
);

CaretRightIcon.propTypes = {
  ...iconPropTypes,
};

CaretRightIcon.defaultProps = {
  ...iconDefaultProps,
};


export default CaretRightIcon;
